import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
  showCart: false,
  cart: [],
  headImgUrl: "",
};
const getters = {};
const mutations = {
  changeShowCart(state, payload) {
    state.showCart = payload;
  },
  changeCart(state, payload) {
    state.cart = payload;
  },
  changeHeadImgUrl(state, payload) {
    state.headImgUrl = payload;
  },
};
const actions = {};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
